import { getField } from 'vuex-map-fields'

const getters = {
  getField
}

export default getters
